export default __webpack_public_path__ + "static/media/Reportes OC.0a2dca89.png";